<template>
  <div>
    <CharterFlightInfoButton class="w-full" @onClick="show" />
    <CharterFlightDescriptionBottomSheet />
  </div>
</template>

<script setup lang="ts">
  import CharterFlightInfoButton from './CharterFlightInfoButton.vue';
  import CharterFlightDescriptionBottomSheet from './CharterFlightDescriptionBottomSheet.vue';

  import { useCharterFlightBottomSheet } from '../model';

  const { show } = useCharterFlightBottomSheet();
</script>
